const PET_DEMOS_STEPS = {
  WELCOME: 0,
  YOUR_POLICY: 1,
};

export { PET_DEMOS_STEPS };
